export class SourceShardByPathPartition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "hotValues",
            "baseName": "hotValues",
            "type": "{ [key: string]: number; }",
            "format": ""
        },
        {
            "name": "coldBuckets",
            "baseName": "coldBuckets",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SourceShardByPathPartition.attributeTypeMap;
    }
    constructor() {
    }
}
